import React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header";
import checkIcon from '../../../../assets/login/tick.png'

const ResetPasswordConfirmation: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            <Header />
            <div className="flex flex-col items-center flex-1 bg-gray-50 p-5">
                <div className="bg-white sm:w-2/5 max-w-xl py-10 px-8 rounded-lg shadow-sm flex flex-col items-center">
                    {/* Tick Icon */}
                    <img
                        src={checkIcon}
                        alt="Success"
                        className="w-20 h-20 mb-4"
                    />

                    {/* Title */}
                    <h2 className="text-2xl font-bold text-gray-800 text-center mt-2 mb-2">
                        Check Your Email
                    </h2>

                    {/* Subtitle */}
                    <p className="text-base font-medium text-gray-800 text-center">
                        We've sent a link to reset your password
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordConfirmation;
